import { BaseCssVarValue } from '@/views/game/components/gameCardSuit/components/baseCssVarInject'

/** 游戏名称暴露的css变量 */
export abstract class _GameNameNormalBase extends BaseCssVarValue {
  abstract cssType: 'default'
  /** 游戏名称字号 */
  ['--game-name-font-size']?: string
}
